import * as yup from 'yup';
import { SuggestionSchema } from '../../../common';

export const VitalInformationSuggestionSchema = yup.object({
  vaccinations: SuggestionSchema.nullable(),
});

export type IVitalInformationSuggestion = yup.InferType<typeof VitalInformationSuggestionSchema>;
